// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2R_hJ","input":"styles_input__eG970"};